import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from '@services/utilities.service';
import { TableColumn } from '@shared/interface/table.interface';
import { BehaviorSubject } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { getDistributorTableColumns } from '../../../distributor.data';
import { IListDistributor } from '../../../interfaces/distributor.interface';

@Component({
  selector: 'app-verification-reject',
  styleUrls: ['./verification-reject.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_REJECT_VERIFICATION"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailReject"
      [actionPathDetail]="'/distributor/detail/reject/verification/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class VerificationRejectComponent implements OnInit, OnDestroy {
  tableColumns: TableColumn[] = getDistributorTableColumns('reject');
  privilegeDetailReject = new BehaviorSubject(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(private router: Router, public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService) {}

  ngOnInit() {
    this.privilegeDetailReject.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_DITOLAK', 'TAB_LIST_VERIFICATION_REJECT', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailReject.value, this.tableColumns);
  }

  onTotalCount = (e: number) => VerificationRejectComponent.totalCount.next(e);

  handleActionDetail = (e: IListDistributor) => this.router.navigate([`/distributor/reject/verification/${e.distributor_id}`]);

  ngOnDestroy() {}

  protected readonly API = API;
}
